import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  AlertTitle,
  Typography,
  Modal,
  IconButton,
  Box,
  Alert,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { driversLicenseExample, passportExample } from '@/assets';
import Styles from './IdRequirementsAlert.styles';

const IdRequirementsAlert = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <Alert severity="info" variant="outlined" className={Styles.alert}>
        <AlertTitle>
          {t('indivualIdRequirements')}:{' '}
          <Typography
            variant="body2"
            className={Styles.link}
            onClick={() => setOpen(true)}
          >
            {t('onbReviewExamples')}
          </Typography>
        </AlertTitle>
      </Alert>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        className={Styles.modal}
      >
        <Box className={Styles.content}>
          <IconButton
            onClick={() => setOpen(false)}
            className={Styles.closeButton}
          >
            <CloseIcon />
          </IconButton>

          <Box className={Styles.requirementText}>
            <Typography>{t('individualIdLegible')}:</Typography>
            <Typography
              component="span"
              variant="caption"
              color="text.secondary"
            >
              {t('individualIdLegibleMessage')}
            </Typography>
          </Box>

          <Box className={Styles.requirementText}>
            <Typography>{t('individualIdComplete')}:</Typography>
            <Typography
              component="span"
              variant="caption"
              color="text.secondary"
            >
              {t('individualIdCompleteMessage')}
            </Typography>
          </Box>

          <Box className={Styles.requirementText}>
            <Typography>{t('individualIdObstacles')}:</Typography>
            <Typography
              component="span"
              variant="caption"
              color="text.secondary"
            >
              {t('individualIdObstaclesMessage')}
            </Typography>
          </Box>

          <Box className={Styles.imageContainer}>
            <Typography variant="subtitle2" className="title">
              {t('onbPassportExample')}
            </Typography>
            <img src={passportExample} alt="Example passport" />
          </Box>

          <Box className={Styles.imageContainer}>
            <Typography variant="subtitle2" className="title">
              {t('onbDriverLicense')}
            </Typography>
            <img src={driversLicenseExample} alt="Example driver's license" />
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default IdRequirementsAlert;
